"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBarsSink = void 0;
const title_bar_1 = require("client/components/title-bar");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./title-bars.less");
let TitleBarsSink = class TitleBarsSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.titlebar = {
            breadcrumbs: true,
            buttons: true,
            icon: true,
            iconIsComponent: true
        };
    }
    render() {
        return (React.createElement("div", { className: "titlebars" },
            React.createElement("h2", null, "Titlebars"),
            React.createElement("h2", null, "Material Title Bar"),
            React.createElement(title_bar_1.TitleBar, { position: "static", user: store_1.usersStore.user.value })));
    }
};
__decorate([
    mobx_1.observable
], TitleBarsSink.prototype, "titlebar", void 0);
TitleBarsSink = __decorate([
    mobx_react_1.observer
], TitleBarsSink);
exports.TitleBarsSink = TitleBarsSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/title-bars/title-bars.tsx
// module id = 3686
// module chunks = 0